import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Form, List } from 'antd-mobile';
import 'moment/locale/ru';
import { createUseStyles } from 'react-jss'

import Icofont from 'react-icofont';
import uuid from 'react-uuid';
import "./index.less"
import REDUX_AkkauntiPolzovatelei from '../../../objects/AkkauntiPolzovatelei/reducer';
import { JSXMap, useAuth } from 'fennec-ui';
import Nl2Br from '../../../common/Nl2br';

var _ = require('lodash');

const useStyles = createUseStyles({
    promoButton: {
        width: "125px",
        fontSize: "14px",
        height: "40px",
        '&.am-button::before': {
            border: "none!important"
        }
    },
    selectPeople: {
        paddingBottom: "5px",
        width: "100%",
        '& .ant-input-prefix': {
            marginRight: "11px"
        },
        '& .ant-input-affix-wrapper': {
            padding: "4px 0px"
        },
        '& .am-list .am-list-body::before': {
            backgroundColor: "transparent"
        },
        '& .am-list .am-list-body::after': {
            backgroundColor: "transparent"
        }
    },
    listMeta: {
        '& .ant-list-item-meta-title': {
            marginBottom: "0"
        },
    },
    itemsListUsluga: {
        '& .ant-list .ant-list-item': {
            borderBottom: "1px solid #e1e1e1",
            alignItems: "flex-start"
        },
    },
    itemsOrderUsluga: {
        '& .ant-list-item': {
            alignItems: "flex-start"
        },
    },
    promo: {
        '& .ant-input-affix-wrapper': {
            paddingLeft: "0px",
        },
        '&': {
            borderBottom: "1px solid darkblue",
        },
        '&:hover': {
            borderBottom: "2px solid darkblue",
        },
    },
    appendButton: {
        '&.am-list-item': {
            width: "100%",
            // backgroundColor: "#d9d9d9",
            boxShadow: "0px 1px 3px 0px rgba(141,141,141,0.74)",
            fontWeight: 500,
            textAlign: "center",
            backgroundColor: "#f1f1f1",
            borderRadius: "5px",
            padding: "0 5px"
        },
        '&.am-list-item .am-list-line-multiple': {
            padding: "5px 13px 5px 5px"
        },
        '&.am-list-item .am-list-line-multiple .am-list-content': {
            paddingTop: "2px",
        }
        // '&.ant-btn:hover': {
        //     color: "#000",
        //     // background: #fff;
        //     boxShadow: "0px 2px 4px 0px rgba(141,141,141,0.74)",
        //     borderColor: "#d9d9d9",
        // },
        // '&.ant-btn:focus': {
        //     color: "#000",
        //     // background: #fff;
        //     boxShadow: "0px 2px 4px 0px rgba(141,141,141,0.74)",
        //     borderColor: "#d9d9d9",
        // }
    },
    peopleInput: {
        '&.am-list-item.am-input-item': {
            height: "25px",
            minHeight: "25px",
            paddingLeft: "0px"
        },
        '&.am-list-item .am-input-label': {
            fontSize: "14px",
            width: "auto",
        },
        '&.am-list-item .am-input-control input': {
            fontSize: "14px",
            fontStyle: "italic",
        },
        '&.am-list-item .am-list-line': {
            paddingRight: "0px"
        }
    },
    listItem: {
        '&.am-list-item': {
            paddingLeft: "5px"
        },
        '&.am-list-item .am-list-line': {
            paddingRight: "5px"
        }
    },
    listRadioItem: {
        '&.am-list-item .am-list-line .am-list-content': {
            fontSize: "14px"
        },
        '&.am-list-item': {
            paddingLeft: "5px"
        },
        '&.am-list-item .am-list-line': {
            paddingRight: "5px"
        }
    },
    categoryPicker: {
        '& .am-picker-popup-title': {
            fontSize: "13px"
        },
        '& .am-picker-col-indicator': {
            // height: "55px"
        },
        '& .am-picker-col-content': {
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            alignContent: "center",
        },
        '& .am-picker-col-item': {
            fontSize: "13px",
            // height: "35px",
            lineHeight: "14px",
            whiteSpace: "break-spaces",

            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
        },
        '& .am-picker-col-item-selected': {
            fontSize: "13px",
            fontWeight: "500"
        }
    },
    categoryPickerListItem: {
        // '&.am-list-item': {
        //     paddingLeft: "0px",
        //     minHeight: "32px"
        // },
        '&.am-list-item .am-list-line .am-list-arrow-horizontal': {
            visibility: "hidden"
        },
        // '&.am-list-item .am-list-line .am-list-content': {
        //     fontSize: "14px",
        //     paddingTop: "3px",
        //     paddingBottom: "3px",
        // },

        '& .am-list-line': {
            display: "block",
        },
        '&.am-list-item .am-list-line .am-list-content': {
            fontSize: "14px",
            paddingBottom: "0px",
        },
        '&.am-list-item .am-list-line .am-list-arrow': {
            position: "absolute",
            right: "0",
            top: "8px",
        },
        // '&.am-list-item .am-list-line .am-list-extra': {
        //     textAlign: "left",
        //     paddingTop: "0px",
        //     paddingBottom: "0px"
        // },
        '&.am-list-item': {
            paddingLeft: "0px"
        },
        '&.am-list-item .am-list-line': {
            paddingRight: "0px"
        },
        '&.am-list-item .am-list-line::after': {
            backgroundColor: "transparent!important"
        },
        '&.am-list-item .am-list-line .am-list-extra': {
            fontSize: "13px",
            textAlign: "left",
            paddingTop: "0px",
            paddingBottom: "0px",
            whiteSpace: "break-spaces",
            // whiteSpace: "initial"
        }
    },
    // checkbox: {
    //     '& .am-checkbox .am-checkbox-inner': {
    //         right: "4px"
    //     }
    // }
})

const Header = ({ icon, title, style }) => {
    return (<span>
        <Icofont icon={icon} style={style} />
        <span>{title}</span>
    </span>);
};
const SingleHeader = ({ icon, title, style }) => {
    return (<Header icon="user-alt-3" title={(title !== undefined) ? title : "Одиночный"} style={{ color: "cadetblue", fontSize: "13px", paddingRight: "4px" }} />);
};
const CoupleHeader = ({ icon, title, style }) => {
    return (<Header icon="users-alt-4" title={(title !== undefined) ? title : "Парный"} style={{ color: "purple", fontSize: "13px", paddingRight: "4px" }} />);
};
const FemaleHeader = ({ icon, title, style }) => {
    return (<Header icon="businesswoman" title={(title !== undefined) ? title : "Женский"} style={{ color: "red", fontSize: "16px", paddingRight: "4px" }} />);
};
const MaleHeader = ({ icon, title, style }) => {
    return (<Header icon="businessman" title={(title !== undefined) ? title : "Мужской"} style={{ color: "blue", fontSize: "16px", paddingRight: "4px" }} />);
};
const SelectCategory = (props) => {
    const classes = useStyles();
    const auth = useAuth();
    const { item, index, title, data, gender, value, onChange } = props;
    const [selection, setSelection] = useState();
    const optionsFunc = (item) => {
        let dance = {};
        if (item) {
            item?.uslugiKlientuKategoriiUslugaKlienta?.forEach(e => {
                if (e.dostupnaRegistratsiya) {
                    dance[e.kategoriya.tantsevalnayaDistsiplinaID] = {
                        value: e.kategoriya.tantsevalnayaDistsiplinaID,
                        label: e.kategoriya.tantsevalnayaDistsiplina.nazvanie,
                        children: _.unionBy(
                            (dance[e.kategoriya.tantsevalnayaDistsiplinaID] && dance[e.kategoriya.tantsevalnayaDistsiplinaID].children) ? dance[e.kategoriya.tantsevalnayaDistsiplinaID].children : [],
                            [{
                                kategoriyaID: e.kategoriya.ID,
                                object: e,
                                ID: e.kategoriya.kategoriyaUchastnikovID,
                                value: e.kategoriya.kategoriyaUchastnikovID,
                                label: e.kategoriya.kategoriyaUchastnikov.nazvanie,
                            }],
                            'ID'),
                    }
                }
            });
        }
        return Object.values(dance);
    };
    useEffect(() => {
        if (value) {
            let a = optionsFunc(item);
            let o = [];
            for (let i = 0; i < a.length; i++) {
                const first = a[i];
                for (let j = 0; j < first.children.length; j++) {
                    const second = first.children[j];
                    if (second && value && value.kategoriya && second.kategoriyaID === value.kategoriya.kategoriyaID) {
                        o.push(first);
                        o.push(second);
                    }
                }
            }
            setSelection((o.length == 2) ? o : undefined);
        }
    }, [item, value])
    return (<>
        <List.Item arrow={false} className={classes.categoryPickerListItem}>
            <span style={{ fontSize: "13px" }}>{title}</span> - <span style={{ fontSize: "13px", color: "#888" }}>{(selection) ? selection.map(o => o.label).join(' / ') : <span style={{ color: "red" }}>Укажите категорию!</span>}</span>
        </List.Item>
    </>);
};
const SelectPeople = (props) => {
    const classes = useStyles();
    const auth = useAuth();
    const user = useSelector(state => state.home.user);
    const { item, index, title, data, gender, prefix, value, onChange, onChangeSilent } = props;
    const hasValue = (object) => {
        if (object === undefined) {
            return false;
        }
        if (object) {
            if (object.polzovatelStrokoi) {
                return true;
            }
            if (object.polzovatel) {
                return true;
            }
            return false;
        }
        return false;
    };
    const displayText = (object) => {
        if (object === undefined) {
            return "Укажите участника!";
        }
        if (object) {
            if (object.polzovatelStrokoi) {
                return object.polzovatelStrokoi;
            }
            if (object.polzovatel) {
                return object.polzovatel.firstname + " " + object.polzovatel.lastname;
            }
            return "Укажите участника!";
        }
        return <></>;
    };
    const triggerFunc = React.useMemo(() => (click) => (
        <>
            {prefix((hasValue(value)) ? "" : undefined)}
            <span style={{ fontSize: "14px" }}>{displayText(value)}</span>
        </>
    ), [value]);
    const filteredValue = (value && value.okazannieUslugiPolzovatelyamUchastik) ? value.okazannieUslugiPolzovatelyamUchastik.filter(i => i.uslugaKlientu.yacheikaUsluga.prilozhenieID) : undefined;
    return (<div className={classes.selectPeople}>
        <div>
            <span>{triggerFunc(() => { })}</span>
        </div>
        {!!value && <Services
            data={data}
            value={filteredValue}
        />}
    </div>);
};
const SelectPartner = (props) => {
    const auth = useAuth()
    const { item, value, onChange, data } = props;
    const user = useSelector(state => state.home.user);

    const display = (object) => {       
        if (!object) {
            return <span>Укажите {(value?.tipTDID === 1)?"ассистента":"партнера"}!</span>;
        }
        if (object) {
            return <span>{object.firstname + " " + object.lastname}</span>;
        }
        return <></>;
    };

    return (<div style={{ display: "flex", gap: "5px" }}>
        <div style={{fontStyle:"italic"}}> - {(value?.tipTDID === 1)?"ассистент":"партнер"} - </div>
        <div>
        {display(value?.partner)}
        </div>
    </div>);
};
const Services = (props) => {
    const auth = useAuth();
    const { item, index, data, value, onChange } = props;
    const onCategoryChange = (value, okazannieUslugiPolzovatelyamUchastikItem) => {
        onChange(value, okazannieUslugiPolzovatelyamUchastikItem);
    };
    const find = (data, i) => {
        let o = (data) ? data.find(e => e.ID === i.uslugaKlientuID) : undefined;
        return o;
    };
    return (<React.Fragment>
        {(!!value && value.length > 0) && <List style={{ backgroundColor: 'white' }} className="picker-list">
            {value.map((i, idx) => {
                return (<div key={idx}>
                    <SelectCategory
                        key={idx}
                        title={i.uslugaKlientu.yacheikaUsluga.nazvanie}
                        auth={auth}
                        item={find(data, i)}
                        value={i}
                        // onChange={(v) => onCategoryChange(v, i)}
                    />
                    {(i?.tipTDID === 1 || i?.tipTDID === 2) && <div style={{ fontSize: "13px" }}>
                        <SelectPartner
                            auth={auth}
                            item={find(data, i)}
                            value={i}
                            data={data}
                            // onChange={(v) => onPartnerChange(v, i)}
                        />
                    </div>}
                </div>)
            })}
        </List>}
    </React.Fragment>);
};
const Male = (props) => {
    const auth = useAuth();
    const { item, index, title, value, onChange, onChangeSilent, usluga } = props;
    const data = (usluga && usluga.uslugiKlientuUslugaNaMeropriyatii) ? usluga.uslugiKlientuUslugaNaMeropriyatii.filter(i => i.yacheikaUsluga.prilozhenieID) : undefined;
    const gender = 1;
    const setMergedObject = (obj) => {
        onChange({
            genderID: gender,
            polzovatelStrokoi: obj.polzovatelStrokoi,
            polzovatelID: _.get(obj, "polzovatel.ID"),
            tovarVZakazeID: item.ID
        });
    };
    return (<div style={{ display: "flex", justifyContent: "flex-start" }}>
        <SelectPeople
            uuid={uuid()}
            auth={auth}
            gender={gender}
            prefix={(title) => <MaleHeader title={title} />}
            item={item}
            index={index}
            data={data}
            value={value}
            onChangeSilent={onChangeSilent}
            onChange={(e) => setMergedObject(e)} />
    </div>);
};
const Female = (props) => {
    const auth = useAuth();
    const { item, index, title, value, onChange, onChangeSilent, usluga } = props;
    const data = (usluga && usluga.uslugiKlientuUslugaNaMeropriyatii) ? usluga.uslugiKlientuUslugaNaMeropriyatii.filter(i => i.yacheikaUsluga.prilozhenieID) : undefined;
    const gender = 2;
    const setMergedObject = (obj) => {
        onChange({
            genderID: gender,
            polzovatelStrokoi: obj.polzovatelStrokoi,
            polzovatelID: _.get(obj, "polzovatel.ID"),
            tovarVZakazeID: item.ID
        });
    };
    return (<div style={{ display: "flex", justifyContent: "flex-start" }}>
        <SelectPeople
            uuid={uuid()}
            auth={auth}
            gender={gender}
            item={item}
            index={index}
            data={data}
            prefix={(title) => <FemaleHeader title={title} />}
            value={value}
            onChangeSilent={onChangeSilent}
            onChange={(e) => setMergedObject(e)} />
    </div>);
};
const Single = (props) => {
    const auth = useAuth();
    const { item, index, value, onChange, onChangeSilent, usluga } = props;
    const data = (usluga && usluga.uslugiKlientuUslugaNaMeropriyatii) ? usluga.uslugiKlientuUslugaNaMeropriyatii.filter(i => i.yacheikaUsluga.prilozhenieID) : undefined;
    const setMergedObject = (obj) => {
        onChange({
            polzovatelStrokoi: obj.polzovatelStrokoi,
            polzovatelID: _.get(obj, "polzovatel.ID"),
            tovarVZakazeID: item.ID
        });
    };
    return (<div style={{ display: "flex", justifyContent: "flex-start" }}>
        <SelectPeople
            uuid={uuid()}
            auth={auth}
            prefix={(title) => <SingleHeader title={title} />}
            item={item}
            index={index}
            data={data}
            value={value}
            onChangeSilent={onChangeSilent}
            onChange={(e) => setMergedObject(e)} />
    </div>);
};
const SingleByGender = (props) => {
    const { auth, item, index, value, onChange, onChangeSilent, usluga } = props;
    const data = (usluga && usluga.uslugiKlientuUslugaNaMeropriyatii) ? usluga.uslugiKlientuUslugaNaMeropriyatii : undefined;
    let genderID = value?.polzovatel?.genderID || value?.genderID;
    const setMergedObject = (obj) => {
        onChange({
            polzovatelStrokoi: obj.polzovatelStrokoi,
            polzovatelID: _.get(obj, "polzovatel.ID"),
            tovarVZakazeID: item.ID
        });
    };
    return (<div style={{ display: "flex", justifyContent: "flex-start" }}>
        <SelectPeople
            uuid={uuid()}
            auth={auth}
            prefix={(title) => (genderID == 1) ? <MaleHeader title={title} /> : (genderID == 2) ? <FemaleHeader title={title} /> : <Header icon="user-alt-3" title="" style={{ color: "cadetblue", fontSize: "13px", paddingRight: "4px" }} />}
            item={item}
            gender={genderID}
            index={index}
            data={data}
            value={value} />
    </div>);
};
const RenderCartItem = (props) => {
    const classes = useStyles();
    const auth = useAuth();
    const { item, index, value, onChange, onInsideChange, deleteItem, zakaz, uslugi, promo } = props;
    const usluga = uslugi.find(e => e.Usluga?.ID === item?.uslugaNaMeropriyatii?.ID)?.Usluga;
    const description = (<div>
        {(!!item.uslugaNaMeropriyatii && !!item.uslugaNaMeropriyatii.opisanie) && <div style={{ fontSize: "13px" }}>
            <pre style={{
                margin: "0",
                padding: "0",
                whiteSpace: "pre-wrap",
                fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, 'Noto Sans', sans- serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol', 'Noto Color Emoji'"
            }}>
                {item.uslugaNaMeropriyatii.opisanie}
            </pre>
        </div>}
    </div>);
    const getPeopleByGender = (array, genderID) => {
        if (!array) return;
        for (let i = 0; i < array.length; i++) {
            const element = array[i];
            if ((element.polzovatel && element.polzovatel.genderID === genderID) ||
                (element.genderID && element.genderID === genderID) ||
                (element.polzovatelStrokoi)) {
                return element;
            }
        }
    };
    return (<>
        <div style={{ display: "flex", justifyContent: "space-between", width: "100%" }}>
            <div style={{ flex: "auto", width: "100%" }}>
                <div style={{ whiteSpace: "initial", fontSize: "14px" }}>
                    <div style={{ fontWeight: "500" }}>{item.uslugaNaMeropriyatii.nazvanie}</div>
                    <div style={{ fontWeight: "300" }}>{description}</div>
                </div>
                <div style={{ alignSelf: "flex-start", textAlign: "start" }}>
                    <div style={{ padding: "5px 0px" }}>
                        {(item.uslugaNaMeropriyatii.vidUslugiID === 1) &&
                            <Male auth={auth} item={item} index={index}
                                value={getPeopleByGender(item.polzovateliVZakazeTovarVZakaze, 1)}
                                usluga={usluga} />
                        }
                        {(item.uslugaNaMeropriyatii.vidUslugiID === 2) &&
                            <Female auth={auth} item={item} index={index}
                                value={getPeopleByGender(item.polzovateliVZakazeTovarVZakaze, 2)}
                                usluga={usluga} />
                        }
                        {(item.uslugaNaMeropriyatii.vidUslugiID === 3) &&
                            <div style={{ display: "flex", justifyContent: "flex-start" }}>
                                <div>
                                    {/* {JSXMap(item.polzovateliVZakazeTovarVZakaze, (e, idx) => {
                                        let genderID = e?.polzovatel?.genderID || e.genderID;
                                        return (<div key={idx} style={{ paddingBottom: "5px" }}>
                                            {genderID == 1 && <Male auth={auth} usluga={usluga} item={item} index={index}
                                                value={e} />}
                                            {genderID == 2 && <Female auth={auth} usluga={usluga} item={item} index={index}
                                                value={e} />}
                                            {(genderID != 1 && genderID != 2) && <Single auth={auth} item={item} index={index}
                                                value={e}
                                                usluga={usluga} />}
                                        </div>)
                                    })} */}
                                    <div style={{ paddingBottom: "5px" }}>
                                        <SingleByGender auth={auth} usluga={usluga} item={item} index={index}
                                            value={_.get(item, "polzovateliVZakazeTovarVZakaze[0]")} />
                                    </div>
                                    <div style={{ paddingBottom: "5px" }}>
                                        <SingleByGender auth={auth} usluga={usluga} item={item} index={index}
                                            value={_.get(item, "polzovateliVZakazeTovarVZakaze[1]")} />
                                    </div>
                                </div>
                            </div>}
                        {(item.uslugaNaMeropriyatii.vidUslugiID === 4) &&
                            <Single auth={auth} item={item} index={index}
                                value={_.get(item, "polzovateliVZakazeTovarVZakaze[0]")}
                                usluga={usluga} />
                        }
                    </div>
                </div>
                {(item?.uslugaNaMeropriyatii?.vklyuchitKommentarii == true) && <div>
                <div className='bg bg-transparent border-grey' style={{ fontSize: "12px", textAlign: "left", margin: "5px 0" }}>
                    <div style={{ fontSize: "11px", color: "rgba(0,0,0,.65)", display: "flex", justifyContent: "space-between" }}>
                        <div><i className="fa fa-comments-o"></i> Комментарий покупателя</div>
                        {/* <div><i className="fa fa-pencil-square-o"></i></div> */}
                    </div>
                    <div><Nl2Br text={item?.kommentarii} /></div>
                </div>
            </div>}
            </div>
            <div style={{ flex: "130px" }}>
                <div style={{ alignSelf: "flex-start", color: "darkblue", textAlign: "end", fontWeight: "500", fontSize: "15px" }}>
                    <div style={(item.tsena !== item.tsenaDoPromokoda) ? { textDecoration: "line-through" } : {}}>{(item.tsenaDoPromokoda).toLocaleString()} руб.</div>
                    {(item.tsena !== item.tsenaDoPromokoda) && <div style={{ color: "red" }}>{(item.tsena).toLocaleString()} руб.</div>}
                </div>
            </div>
        </div>
    </>)
};
function CollectionList(props) {
    const classes = useStyles();
    const auth = useAuth();
    const { zakaz, uslugi } = props;
    const [loading, setLoading] = useState(false);
    return (
        <div className='order-add-list'>
            <List>
                {!!(zakaz && zakaz?.tovariVZakazeZakaz) && zakaz?.tovariVZakazeZakaz?.map((item, index) => (
                    <List.Item key={index} className={classes.listItem}>
                        <RenderCartItem
                            auth={auth}
                            item={item}
                            index={index}
                            zakaz={zakaz}
                            uslugi={uslugi}
                        />
                    </List.Item>
                ))}
            </List>
            <div style={{ display: "flex", justifyContent: "space-between", fontWeight: "500", fontSize: "16px", padding: "10px 0px 0px 0px" }}>
                <div>
                    ИТОГО:
                </div>
                {(zakaz && zakaz?.obshchayaSumma) && <div>
                    {(zakaz?.obshchayaSumma).toLocaleString()} руб.
                </div>}
            </div>
        </div>
    );
}
function Dimmy({ constant, value, onChange, render }) {
    useEffect(() => {
        onChange(constant || value);
    }, [constant, value]);
    return <>{render && render(constant || value)}</>;
}
export default function PaymentForm(props) {
    const classes = useStyles();
    const auth = useAuth();
    const { form, data } = props;
    const [zakaz, setZakaz] = useState({});
    const [messages, setMessages] = useState([]);
    const [uslugi, setUslugi] = useState([]);
    const [akkaunti, setAkkaunti] = useState();
    const akkauntiPolzovatelei = useSelector(REDUX_AkkauntiPolzovatelei.selector.array);
    useEffect(() => {
        form.resetFields();
    }, []);
    useEffect(() => {
        setZakaz(data?.cart?.zakaz);
        setMessages(data?.cart?.messages);
        setUslugi(data?.cart?.data);
    }, [data])
    useEffect(() => {
        if (akkauntiPolzovatelei) {
            setAkkaunti(akkauntiPolzovatelei.map(e => e.akkaunt));
        }
    }, [akkauntiPolzovatelei]);

    const ByAccount = (akkaunti) => {
        if (!akkaunti) return {};
        for (let i = 0; i < akkaunti.length; i++) {
            const akkaunt = akkaunti[i];
            if (akkaunt && akkaunt?.akkauntTypeID == 2) {
                return akkaunt;
            }
        }
        return {};
    };
    const acc = ByAccount(akkaunti);
    const payCard = () => {
        if (!zakaz) return 0;
        if (!acc) return 0;
        if (!data?.cart?.razreshitSpisanieSoScheta) return zakaz.obshchayaSumma;
        if (zakaz?.obshchayaSumma - acc.ostatok < 0) return 0;
        return (zakaz?.obshchayaSumma - acc.ostatok);
    };
    const payAcc = () => {
        if (!acc.ostatok) return 0;
        if (!data?.cart?.razreshitSpisanieSoScheta) return 0;
        if (acc.ostatok >= zakaz?.obshchayaSumma) return zakaz?.obshchayaSumma;
        if (acc.ostatok < zakaz?.obshchayaSumma) return acc.ostatok;
        return 0;
    };
    return (
        <>
            <div style={{ fontSize: "24px" }}>
                Подтверждение заказа
            </div>
            <CollectionList auth={auth} zakaz={zakaz} promo={zakaz?.promokod} uslugi={uslugi} />
            {akkaunti && <div className='order-form' style={{ fontWeight: "500", fontSize: "14px", padding: "10px 0px 25px 0px" }}>
                <Form
                    form={form}
                    onFinish={props.submit}
                    // labelalign={"left"}
                    layout={"vertical"}
                >
                    <Form.Item
                        name="fromAccount"
                    >
                        <Dimmy constant={payAcc()} render={(value) =>
                            <div style={{ display: "flex", justifyContent: "space-between" }}>
                                <div>
                                    {/* {(payAcc()<0)?`Долг по счету №${acc.nomerAkkaunta}:`:`Спишем со счета №${acc.nomerAkkaunta}:`} */}
                                    {value && ((value < 0) ? `Долг по счету:` : `Спишем со счета:`)}
                                </div>
                                <div>
                                    {value && ((value < 0) ? Math.abs(value).toLocaleString() + " руб." : value.toLocaleString() + " руб.")}
                                </div>
                            </div>
                        } />
                    </Form.Item>
                    <Form.Item
                        name="byCard"
                    >
                        <Dimmy constant={payCard()} render={(value) =>
                            <div style={{ display: "flex", justifyContent: "space-between", fontSize: "18px", color: "red" }}>
                                <div>
                                    ОПЛАТИТЬ КАРТОЙ:
                                </div>
                                <div>
                                    {(value === undefined) ? 0 : value.toLocaleString()} руб.
                                </div>
                            </div>
                        } />
                    </Form.Item>
                </Form>
            </div>}
        </>
    );
}
// PaymentForm.whyDidYouRender = true
// CollectionList.whyDidYouRender = true
